function getFooterLinks() {
    const FOOTER_LINKS = [
        {sectionName: "Product", links: [{text: "Software Changelogs", link: "/software-changelogs"}, {text: "Web Dashboard", link: "/dashboard"}, {text: "Pricing Plans", link: "/subscription-plans"}]},
        {sectionName: "Resources", links: [{text: "Tutorials", link: "#"}, {text: "Community Discord", link: "#"}, {text: "Support", link: "#"}]},
        {sectionName: "Legal", links: [{text: "Privacy Policy", link: "/legals/privacy-policy"}, {text: "Terms of Service", link: "/legals/terms-of-service"}, {text: "Cookie Policy", link: "/legals/cookie-policy"}]},
    ]

    return FOOTER_LINKS
}

export default getFooterLinks;